// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1t42N","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__xtM0B"};